import * as React from "react";
import {
  List, Datagrid, TextField, Show, TabbedShowLayout, Create, SimpleForm,
  TextInput, SelectInput, useRecordContext,
} from "react-admin";
import { Box } from "@mui/material";
import { JsonField } from "../../components/JsonField";
import { ConfirmActionButton } from "../../components/ConfirmActionButton";
import { RemoteList, fmtDate } from "../../components/RemoteList";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";
import { FrDateField } from "../../components/FrDateField";
import { UserRefField } from "../../components/ui";

const pick = (row, ...keys) => {
  for (const k of keys) {
    const parts = k.split(".");
    let v = row;
    for (const p of parts) v = v == null ? undefined : v[p];
    if (v != null && v !== "") return v;
  }
  return undefined;
};

// GET /echos : filtres theme + authorType (UserEnum.valueOf → PATIENT | PRO),
// pagination 1-indexée (page, limit). Pas de recherche plein texte.
const AUTHOR_TYPES = [
  { id: "PATIENT", name: "Patient" },
  { id: "PRO", name: "Professionnel" },
];
const filters = [
  <TextInput key="theme" source="theme" label="Thème" alwaysOn />,
  <SelectInput key="authorType" source="authorType" label="Type d'auteur" choices={AUTHOR_TYPES} />,
];

const Hide = () => {
  const r = useRecordContext();
  if (!r) return null;
  return (
    <ConfirmActionButton label="Supprimer l'écho (modération)"
      color="error"
      confirmTitle="Supprimer cet écho"
      confirmText="Suppression définitive (cascade likes + commentaires). Irréversible."
      successMessage="Écho supprimé"
      onConfirm={() => httpClient(`${API_BASE_URL}/echos/${r.id}`, {
        method: "DELETE",
      })}
    />
  );
};

const Form = () => (
  <SimpleForm>
    <TextInput source="content" label="Contenu" multiline minRows={4} fullWidth />
    <TextInput source="theme" label="Thème" />
    <TextInput source="authorId" label="Auteur" />
    <SelectInput source="authorType" label="Type d'auteur" choices={AUTHOR_TYPES} />
  </SimpleForm>
);

export default {
  list: () => (
    <List filters={filters} sort={{ field: "createdAt", order: "DESC" }}>
      <Datagrid rowClick="show">
        <TextField source="content" />
        <TextField source="theme" />
        <UserRefField source="authorId" label="Auteur" />
        <TextField source="authorType" />
        <FrDateField source="createdAt" showTime />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label="Écho">
          <TextField source="content" />
          <TextField source="theme" />
          <UserRefField source="authorId" label="Auteur" />
          <TextField source="authorType" />
          <TextField source="likeCount" label="Likes" />
          <TextField source="commentCount" label="Commentaires" />
          <FrDateField source="createdAt" showTime />
          <Box sx={{ mt: 2 }}><Hide /></Box>
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Commentaires">
          <RemoteList
            buildPath={(r) => `/echos/${r.id}/comments?limit=100`}
            extract={(json) => json?.items || json?.content || (Array.isArray(json) ? json : [])}
            emptyText="Aucun commentaire"
            columns={[
              { key: "content", label: "Commentaire", render: (c) => pick(c, "content", "text") || "—" },
              { key: "author", label: "Auteur", render: (c) => pick(c, "authorName", "authorId") || "—" },
              { key: "date", label: "Date", render: (c) => fmtDate(pick(c, "createdAt", "date")) },
            ]}
          />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Brut">
          <JsonField source="__all__" />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  ),
  create: () => <Create><Form /></Create>,
};
